import React, { Component } from 'react';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import InputAdornment from "@material-ui/core/InputAdornment";
import SearchIcon from "@material-ui/icons/Search";
import './SalesMeetingFormSimple.css';
import firebase from 'firebase';
import { isNullOrUndefined } from "util";


class SalesMeetingFormSimpleComponent extends React.Component {
    
    constructor(props){

        super(props);
        //showAttendees, hideTitle
        

        this.state = {
            company: JSON.parse(JSON.stringify(this.props.company)),
            attendees: JSON.parse(JSON.stringify(this.props.attendees))
        }

        this.handleChange = this.handleChange.bind(this);
        this.renderCompanyName = this.renderCompanyName.bind(this);
        this.renderAttendee = this.renderAttendee.bind(this);
        this.addAttendee = this.addAttendee.bind(this);
        this.canSave = this.canSave.bind(this);
        this.saveDetails = this.saveDetails.bind(this);
    }

    handleChange(event, type, index){
        if(type=="company"){
            let company = this.state.company;
            company = event.target.value;
            if(!isNullOrUndefined(company)){
                company = company.replace("\n","");
            }
            this.setState({company: company});            
        }
        else if(type=="attendees"){
            let attendees = this.state.attendees;
            if(!isNullOrUndefined(index) && index<attendees.length){
                attendees[index]=event.target.value;;
            }
            this.setState({attendees:attendees})
        }
    }

    renderCompanyName(){
        let scope = this;
        return (
            <div style={{marginTop:'5px', textAlign:'center'}}>
                <p style={{fontSize:'16px',fontWeight:'bold'}}>Sales Intelligence for Cybersecurity</p>
                <form>
                    <label>
                        <TextField 
                            type="text"
                            variant="outlined"
                            multiline
                            label = "Enter a company name"
                            placeholder = "Enter a company name"
                            value={this.state.company}
                            onChange={(e) => { this.handleChange(e,"company")}}
                            onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                    if (scope.props.enterKeyCompanyEnabled)
                                    {
                                        if(scope.canSave()){
                                            scope.saveDetails();
                                        }
                                    }
                                }
                             }}
                            rowsMax="2"
                            rowsMin="1"
                            InputProps={{
                                endAdornment: (
                                  <InputAdornment>
                                  {scope.canSave() && scope.props.showSearchButtonAsIcon?
                                        <IconButton onClick={this.saveDetails}>
                                            <SearchIcon />
                                        </IconButton>
                                        :
                                        null
                                  }
                                  </InputAdornment>
                                )
                              }}
                            style={{
                                background: 'white',
                                marginTop:'6px',
                                marginBottom:'6px',
                                width:'95%',
                                maxWidth:'550px',
                                minWidth: '200px'
                                }}/>
                    </label>
                </form>
            </div>
        )
    }

    renderAttendee(index){
        let val="";
        if(index < this.state.attendees.length){
            val = this.state.attendees[index];
        }

        return (
            <div style={{marginTop:'5px', textAlign:'left'}}>                
                <form>
                    <label>
                        <TextField 
                            type="text"
                            variant="outlined"
                            multiline
                            placeholder = "Attendee name"
                            value={val}
                            onChange={(e) => { this.handleChange(e,"attendees",index)}}
                            rowsMax="2"
                            rowsMin="1"
                            style={{
                                background: 'white',
                                marginTop:'6px',
                                marginBottom:'6px',
                                width:'95%'
                                }}/>
                    </label>
                </form>
            </div>
        )
    }

    addAttendee(){
        let attendees = this.state.attendees;
        if(attendees.length==0 || attendees[attendees.length - 1].trim().length>0){
            attendees.push("");
            this.setState({
                attendees: attendees
            });
        }
    }

    canSave(){
        if(!isNullOrUndefined(this.state.company) && this.state.company.trim().length>0)
            return true;
        return false;
    }

    saveDetails(){
        /* this.setState({
            company: "",
            attendees: [""]
        }); */
        let company = this.state.company;
        if(company.length > 0)
            company = company.charAt(0).toUpperCase() + company.slice(1);
        this.setState({
            company: company
        })
        this.props.createMeeting(company, this.state.attendees);
        
    }


    render(){

        let renderAttendees = null;
        if(!isNullOrUndefined(this.state.attendees)){
            renderAttendees = this.state.attendees.map((attendee, index) =>
                this.renderAttendee(index)
            );
        } 


        return (
        <div>
            {this.props.hideTitle?
                null
                :
                <h3 style={{textAlign:'center'}}>Meeting</h3>
            }
            
            <div style={{marginLeft:'1em'}}>
                <div>{this.renderCompanyName()}</div>
                {this.props.hideAttendees?
                    null
                    :
                
                    <div>
                        <div style={{textAlign:'left'}}>Attendees 
                            <span>
                                <IconButton 
                                    color="primary"
                                    variant="contained"
                                    className="" 
                                    onClick={this.addAttendee}>
                                        <AddCircleIcon/>
                                </IconButton>
                            </span> 
                        </div>
                        <div>{renderAttendees}</div>
                    </div>
                } 
                {this.canSave() && !(this.props.hideSaveButton)?
                    <div style={{textAlign:'center'}}>
                        <Button 
                            color="primary"
                            variant="contained"
                            className="genericButton saveTaskButton" 
                            onClick={this.saveDetails}>
                                <div>{this.props.saveButtonText? <span>{String(this.props.saveButtonText)}</span>: "Save"}</div>
                        </Button>
                    </div>
                    :
                    null
                }   
            </div>

        </div>
        )
    }

}
export default SalesMeetingFormSimpleComponent;